import { Loader } from 'limetray-ui-kit';
import './LtLoader.scss';

const LtLoader = ({
  message,
  size = 'large',
  active = true,
  inline,
  className = '',
  inverted = false,
}) => {
  const containerClass = inline ? 'inlineLoader' : 'overlayLoader';

  return (
    <div className={`${containerClass} ${className}`}>
      <Loader
        active={active}
        size={size}
        inline={inline}
        inverted={inverted}
      />
      {message && <span className="loaderMessage">{message}</span>}
    </div>
  );
};

export default LtLoader;
